<script lang="ts">
    import {createEventDispatcher} from 'svelte';

    export let value = false;
    export let title;
    let inputEl;


    const dispatch = createEventDispatcher();

    function updateValue() {
        dispatch('configValueChanged', value);
    }

</script>

<div style="width: 100%" class="flex flex-row bg-center pt-1 w-fit form-control no-animation">
    <label class="basis-1/3 text-input-label">{title}: </label>
    <input type="checkbox" bind:checked="{value}" on:change={() => updateValue()}
           class="checkbox checkbox-sm"/>
</div>
